export default "__VITE_ASSET__ZZkGKA46__"